export const FILE_STORAGE_LANGUAGE = 'QmzSYwddqhm49PrRMzSrJf3AvmmreXMKtr1u56nbTjBFVmCzS8N';

export const EMBEDDING_VECTOR_LANGUAGE = 'QmzSYwdePqDwYwVj2ChhMnyD5Z3Zxue916dUFrptLhhQv3AqUDR';
